import React from 'react';
import { reduxForm, Field, change as FormChange } from 'redux-form';
import { connect } from 'react-redux';
import { map } from 'ramda';
import RichTextEditor from 'react-rte';

import LoggedIn from './LoggedIn';

import {youtubeLinkUpdateProcess} from '../actions/processQueueActions';

const renderInput = ({
    input,
    label,
    type,
    helpText,
}) => (
    <div className="form-group">
        <label className="col-sm-3 control-label">
            {label}
        </label>
        <div className="col-sm-9">
            <input {...input} type={type} className="form-control" placeholder={label} />
            <p className="help-block" id="help-block">{helpText}</p>
        </div>
    </div>
);
class YoutubeLinkForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        editMode: false,
      };
    }

    setEditMode(mode) {
        this.setState({ editMode: mode });
    }


    render() {
        const { getYoutubeVideos } = this.props;

        const editForm = !this.state.editMode ? (<></>) : (
            <div className="row">
                <div className="col">
                    <form
                        className="form-horizontal"
                        style={{
                            
                        }}
                        onSubmit={(e) => {
                            e.preventDefault();
                            getYoutubeVideos('youtubeLink');

                        }}
                    >
                        <Field
                            component={renderInput}
                            type="text"
                            value=""
                            name="youtube_playlist_id"
                            id="youtube_playlist_id"
                            label="Playlist ID"
                            helpText="Enter Playlist ID you are pulling from"
                        />
                        <div className="">
                            <button className="btn btn-primary" type="submit">
                                Save
                            </button>
                            <br />
                            <br />
                        </div>
                    </form>
                   
                </div>
            </div>
        );

        return (
            <LoggedIn>
                <div>
                    <button style={{ float: 'right' }} className="btn btn-link" onClick={ () => this.setEditMode(!this.state.editMode) }>Update Youtube Videos</button>
                    {editForm}
                </div>
            </LoggedIn>
        )
    }
};

YoutubeLinkForm = reduxForm({
    // a unique name for the form
    form: 'youtubeLink',
    destroyOnUnmount: false,
    enableReinitialize: true,
})(YoutubeLinkForm);

const mapState = () => ({});

const mapDispatch = (dispatch) => {
    return {
        getYoutubeVideos(form) {
            dispatch(youtubeLinkUpdateProcess(form));
        },
    };
};

export default connect(mapState, mapDispatch)(YoutubeLinkForm);
